import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../lib/auth-context';

interface Props {
  children: ReactNode;
  /** 'staff' = require staff user; 'client' = require client user; absent = either kind. */
  kind?: 'staff' | 'client';
  /** If unauthenticated, route here. Defaults to the unified /sign-in. */
  signInTo?: string;
}

export function RequireAuth({ children, kind, signInTo = '/sign-in' }: Props) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ minHeight: '60vh', display: 'grid', placeItems: 'center', color: 'var(--fg-mute)', fontSize: 13 }}>
        Checking session…
      </div>
    );
  }

  if (!user) {
    return <Navigate to={signInTo} replace state={{ from: location.pathname }} />;
  }

  if (kind && user.kind !== kind) {
    // Staff trying to access client portal, or vice versa — bounce to the right home.
    return <Navigate to={user.kind === 'staff' ? '/admin' : '/portal'} replace />;
  }

  return <>{children}</>;
}
